
import { Vue, Component, Prop } from 'vue-property-decorator';
import InvoiceHeader from '@/components/invoice/InvoiceForm/InvoiceFormHeader.vue';
import moment from 'moment';
import StepProgress from '@/components/invoice/InvoiceForm/invoiceStepper.vue';
import NavGrayArrow from '@/components/icons//NavGrayArrow.vue';
import GET_COMPANY from "@/apollo/company/GetCompany.gql";
import Step1 from './inoviceForm/Stepper/Stepper1.vue';
import Step2 from './inoviceForm/Stepper/Stepper2.vue';
import Step3 from './inoviceForm/Stepper/Stepper3.vue';
import { User , Company} from '@/generated/graphql';

import GET_INVOICE from '@/apollo/invoice/GetInvoice.gql';

@Component({
	components: {
		InvoiceHeader,
		StepProgress,
		NavGrayArrow,
		Step1,
		Step2,
		Step3,
	},
})
export default class SubmitForm extends Vue {
	@Prop({ type: Object, required: true }) readonly currentUser!: User;

	steps = [
		{ label: 'Invoice Details' },
		{ label: 'Select Client hours' },
		{ label: 'Review & Submit' },
	];
	activeStep: number = 0;
	companyId: string | number = 0;
	inoviceRecord = {};

	created() {
		if (this.$route.params.id) {
			this.$apollo
				.query({
					query: GET_INVOICE,
					variables: {
						id: this.$route.params.id,
					},
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					let invoice = data.invoice_by_pk;
					this.inoviceRecord = {
						invoice_ref: invoice.invoice_ref,
						...(this.currentUser.role === 'ADMIN' && {
							resource_id: {
								label: `${invoice?.user?.given_name} ${invoice?.user?.family_name}`,
								id: invoice.user.id,
							},
						}),
						selectedItems: invoice.project_activities
							.filter((activity) =>
								activity.project_activity_times.some(
									(time) => time.status === 'APPROVED'
								)
							)
							.map((activity) => {
								const approvedTimes =
									activity.project_activity_times.filter(
										(time) => time.status === 'APPROVED'
									);
								const totalHours =
									this.calculateTotalHours(approvedTimes);
								const totalFormattedHours =
									this.formatedcalculateTotalHours(
										approvedTimes
									);
								const totalAmount = this.calculateTotalAmount(
									totalHours,
									activity.budget
								);
								return {
									id: activity.id,
									project_id: activity.project_id,
									date: this.formatDate(activity.start_date),
									task: activity.title,
									rate: `$${activity.budget}/hr`,
									hours: totalFormattedHours,
									totalAmount: `$${totalAmount.toFixed(2)}`,
									notes: activity.note,
									status: 'APPROVED',
								};
							}),
						company_id: {
							label: invoice.project.company.business_name,
							id: invoice.project.company.id,
						},
						project_id: {
							label: invoice.project.name,
							id: invoice.project.id,
						},
						file: invoice.file,
						total_hours: invoice.total_hours,
						total_amount: invoice.total_amount,
						currency: 'CAD',
						external_link: invoice.external_link,
					};
				})
				.catch((error) => {});
		}
	}



	goToNextStep(state, step) {
		if (typeof step === 'number') {
			this.activeStep = step;
			
			this.inoviceRecord = {
				...this.inoviceRecord,
				...state,
			};
			return;
		}
		if (this.activeStep < this.steps.length - 1) {
			this.activeStep++;
			this.inoviceRecord = {
				...this.inoviceRecord,
				...state,
			};
		}
	}
	goToPreviousStep() {
		if (this.activeStep > 0) {
			this.activeStep--;
		}
	}
	gotoStep(step) {
		this.activeStep = step;
	}
	handleBack() {
		if (this.activeStep > 0) {
			this.activeStep--;
		} else {
			this.$router.push('/invoice');
		}
	}

	handleClose() {
		this.$router.push('/invoice');
	}
	calculateTotalHours(approvedTimes) {
		return approvedTimes.reduce((sum, time) => sum + time.time, 0) / 3600;
	}
	formatedcalculateTotalHours(approvedTimes) {
		const totalSeconds = approvedTimes.reduce(
			(sum, time) => sum + time.time,
			0
		);
		const hours = Math.floor(totalSeconds / 3600);
		const minutes = Math.floor((totalSeconds % 3600) / 60);
		return `${hours}h ${minutes}m`;
	}

	calculateTotalAmount(hours, budget) {
		return hours * budget;
	}
	formatDate(dateString) {
		return moment(dateString).format('MMM D, YYYY');
	}
}
